<template>
    <div class="iban">
        <div class="form-row" >
            <div class="col-2">
                <div class="form-group">
                    <label class="label" for="iban-country">Land</label>
                    <div class="control">
                        <input :class="['form-control', (isDirty) ? (isValid) ?'is-valid' : 'is-invalid' : '']" required minlength="2" maxlength="2" type="text" placeholder="NL" v-model="iban.country" name="iban-country" id="iban-country" @change="change">
                    </div>
                </div>
            </div>
            <div class="col-2">
                <div class="form-group">
                    <label class="label" for="iban-checkNo">Controle</label>
                    <div class="control">
                        <input :class="['form-control', (isDirty) ? (isValid) ?'is-valid' : 'is-invalid' : '']" required minlengt="2" maxlength="2" type="text" placeholder="00" v-model="iban.checkNo" name="iban-checkNo" id="iban-checkNo" @change="change">
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label class="label" for="iban-bank">Bank</label>
                    <div class="control">
                        <input :class="['form-control', (isDirty) ? (isValid) ?'is-valid' : 'is-invalid' : '']" required minlength="4" maxlength="4" type="text" placeholder="RABO" v-model="iban.bank" name="iban-bank" id="iban-bank" @change="change">

                    </div>
                </div>
            </div>
            <div class="col-5">
                <div class="form-group">
                    <label class="label" for="iban-account">Rekening</label>
                    <div class="control">
                        <input :class="['form-control', (isDirty) ? (isValid) ?'is-valid' : 'is-invalid' : '']" required minlength="10" maxlength="16" type="text" placeholder="0000000000" v-model="iban.account" name="iban-account" id="iban-account" @change="change">
                        <div class="invalid-feedback">
                            Ongeldige IBAN rekening.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="invalid-feedback">
            Ongeldige IBAN-rekening.
        </div>
    </div>
</template>

<script>
const alphabet = ["a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"];
const modulo = (divident, divisor) =>  {
    var cDivident = '';
    var cRest = '';

    for (var i in divident ) {
        var cChar = divident[i];
        var cOperator = cRest + '' + cDivident + '' + cChar;

        if ( cOperator < parseInt(divisor) ) {
                cDivident += '' + cChar;
        } else {
                cRest = cOperator % divisor;
                if ( cRest == 0 ) {
                    cRest = '';
                }
                cDivident = '';
        }

    }
    cRest += '' + cDivident;
    if (cRest == '') {
        cRest = 0;
    }
    return cRest;
}
    export default {
        name: 'iban',
        props: ['v', 'account'],
        data() {
            return {
                iban: {
                    country: 'NL',
                    checkNo: '',
                    bank: '',
                    account: ''
                },
                isDirty: false,
            }
        },
        methods:
        {
            change() {
                this.isDirty = true;
                if(this.isValid)
                {
                    this.$emit('update', this.computedIban);
                }
                this.$emit('valid', this.isValid);
            }
        },
        mounted() {
        },
        computed: {
            isValid() {
                let countryNumeric = '';
                for(var index1 in this.iban.country)
                {
                    countryNumeric = countryNumeric.concat(alphabet.indexOf(this.iban.country[index1].toLowerCase()) + 10);
                }

                let bankNumeric = '';
                for(var index2 in this.iban.bank)
                {
                    bankNumeric = bankNumeric.concat(alphabet.indexOf(this.iban.bank[index2].toLowerCase()) + 10);
                }

                let ibanNumeric = bankNumeric.concat(this.iban.account).concat(countryNumeric).concat(this.iban.checkNo);

                if(modulo(ibanNumeric, 97) == 1)
                    return true;

                return false;
            },
            computedIban() {
                return this.iban.country.concat(this.iban.checkNo).concat(this.iban.bank).concat(this.iban.account).toUpperCase();
            }
        },
        watch: {
            account(val) {
                if(val) {
                    let trimmed = this.account.replace(/\s/g, "");
                    this.iban.country = trimmed.substring(0,2);
                    this.iban.checkNo = trimmed.substring(2,4);
                    this.iban.bank = trimmed.substring(4,8);
                    this.iban.account = trimmed.substring(8, val.length);
                    this.change();
                }
            }
        }
    }
</script>